// Based on https://mui.com/material-ui/react-tabs/#nav-tabs
import { Box, Tab, Tabs } from '@mui/material';
import { useLocation } from 'react-router-dom';
import { RouterLink } from './RouterLink';

interface LinkTabProps {
  label?: string;
  href?: string;
  selected?: boolean;
}

function LinkTab(props: LinkTabProps) {
  return (
    <Tab
      component={RouterLink}
      to={props.href || ''}
      aria-current={props.selected && 'page'}
      onClick={() => window.scrollTo(0, 0)}
      variant="secondary"
      {...props}
    />
  );
}

type NavLinkItem = {
  label: string;
  href: string;
};

type Props = {
  tabs: NavLinkItem[];
};

export const NavTabs = ({ tabs }: Props) => {
  const location = useLocation();
  const indexValue = tabs.findIndex((tab) => tab.href === location.pathname);

  return (
    <Box sx={{ width: '100%' }}>
      <Tabs
        value={indexValue}
        aria-label="nav tabs"
        role="navigation"
        TabIndicatorProps={{
          hidden: true
        }}
      >
        {tabs.map((tab, index) => (
          <LinkTab key={index} label={tab.label} href={tab.href} />
        ))}
      </Tabs>
    </Box>
  );
};
